module.exports = __webpack_public_path__ + "img/mile4m-m@1.6412c774.webp";